import { useStaticQuery, graphql } from "gatsby"

export const useFooterQuery = () => {
  const { wp} = useStaticQuery(
    graphql`
    query FooterQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            commonItemsLogo {
              localFile {
                childImageSharp{
                  gatsbyImageData
                }
              }
            }
            commonItemsFooterText
            commonItemsFooterNavTitle
            commonItemsFooterContactTitle
            commonItemsFooterContactInfo {
              commonItemsLabel1
              commonItemsAddress
              commonItemsLink {
                url
              }
              commonItemsLabel2
              commonItemsPhoneNumber
            }
            commonItemsOfficeHoursTitle
            commonItemsOfficeHoursText
            commonItemsLicensesTitle
            commonItemsLicensesText
            commonItemsSocialMedia {
              commonItemsSocialMediaIcon {
                localFile {
                  childSvg {
                    content {
                      data
                    }
                  }
                }
              }
              commonItemsSocialMediaLink {
                url
              }
            }
            commonItemsCopyright
          }
        }
      }
    }
    `
  )
  return wp.acfOptionsCommonItems.commonItems
}
